import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import personalInf from '@/components/personalInf'
import newjob from '@/components/newjob'
import researchrep from '@/components/researchrep'
import corpinfo from '@/components/corpinfo'
import PieChart from '@/components/PieChart'
import cvscreening from '@/components/cvscreening'
import register from '@/components/register'
import Header from '@/components/Header'
import userInfo from '@/components/userInfo'
import usersystem from '@/components/usersystem'
import CareerQuiz from '@/components/CareerQuiz'
import qiyesystem from '@/components/qiyesystem'
import JobBoard from '@/components/JobBoard'
import zhiyefangxiang from '@/components/zhiyefangxiang'
import usereport from '@/components/usereport'
import qiyereport from '@/components/qiyereport'
import qiyeJob from '@/components/qiyeJob'
import downloadresume from '@/components/downloadresume'
import downreport from '@/components/downreport'
import recommend from '@/components/recommend'
import Footer from '@/components/Footer'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/personalInf',
      name: 'personalInf',
      component: personalInf
    },
    {
      path: '/newjob',
      name: 'newjob',
      component: newjob
    },
    {
      path: '/researchrep',
      name: 'researchrep',
      component: researchrep
    },
    {
      path: '/corpinfo',
      name: 'corpinfo',
      component: corpinfo
    },
    {
      path: '/PieChart',
      name: 'PieChart',
      component: PieChart
    },
    {
      path: '/cvscreening',
      name: 'cvscreening',
      component: cvscreening
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/Header',
      name: 'Header',
      component: Header
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo
    },
    {
      path: '/usersystem',
      name: 'usersystem',
      component: usersystem
    },
    {
      path: '/CareerQuiz',
      name: 'CareerQuiz',
      component: CareerQuiz
    },
    {
      path: '/qiyesystem',
      name: 'qiyesystem',
      component: qiyesystem
    },
    {
      path: '/JobBoard',
      name: 'JobBoard',
      component: JobBoard
    },
    {
      path: '/zhiyefangxiang',
      name: 'zhiyefangxiang',
      component: zhiyefangxiang
    },
    {
      path: '/usereport',
      name: 'usereport',
      component: usereport
    },
    {
      path: '/qiyereport',
      name: 'qiyereport',
      component: qiyereport
    },
    {
      path: '/qiyeJob',
      name: 'qiyeJob',
      component: qiyeJob
    },
    {
      path: '/downloadresume',
      name: 'downloadresume',
      component: downloadresume
    },
    {
      path: '/downreport',
      name: 'downreport',
      component: downreport
    },
    {
      path: '/recommend',
      name: 'recommend',
      component: recommend
    },
    {
      path: '/Footer',
      name: 'Footer',
      component: Footer
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js